import { Component, Input, OnChanges, OnInit, Output, SimpleChanges, EventEmitter } from '@angular/core';
import { AdminService } from '../services/admin.service';
import { Router } from '@angular/router';
import { PageEvent } from '@angular/material/paginator';
import { SpinnerHandlerService } from '../services/spinner.service';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class TableComponent implements OnInit, OnChanges {

  @Input() columnList;
  @Input() tableData;
  @Input() tableFor;
  @Input() totalData;
  @Output() paginationVal = new EventEmitter();

  //Pagination variables
  currentPage = 1;
  totalReceiveData: number = 10;

  // length = 50;
  // pageSize = 10;
  // pageIndex = 0;
  // pageSizeOptions = [5, 10, 25];
  // pageEvent: PageEvent;

  constructor(private services: AdminService, private router: Router, public spinnerService:SpinnerHandlerService) {
  }

  ngOnInit(): void {
    // setTimeout(() => {
    //   console.log('tableData in table', this.tableData);
    // }, 3000)
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log(changes);
    if (changes?.totalData?.currentValue) {
      this.totalReceiveData = changes?.totalData?.currentValue;
    }
  }

  // handlePageEvent(e: PageEvent) {
  //   console.log(e);
  //   this.pageEvent = e;
  //   this.length = e.length;
  //   this.pageSize = e.pageSize;
  //   this.pageIndex = e.pageIndex;

  //   this.paginationVal.emit(e);
  // }

  facilityNameClick(userId) {
    let encryptedParams = btoa(`userId=${userId}`);
    this.router.navigateByUrl(`/admin/facility-info?${encryptedParams}`);
    sessionStorage.setItem('isClearFilter', 'false');
  }

  editCSEProfile(userId) {
    let encryptedParams = btoa(`cseId=${userId}`);
    this.router.navigateByUrl(`/admin/add-mapping-form?${encryptedParams}`);
    sessionStorage.setItem('isClearFilter', 'false');
  }

  editAddCseForm(userId) {
    let encryptedParams = btoa(`userId=${userId}`);
    this.router.navigateByUrl(`/admin/add-cse-form?${encryptedParams}`);
    sessionStorage.setItem('isClearFilter', 'false');
  }

  handlePagination(currentPage) {
    console.log(currentPage)
    this.currentPage = currentPage;
    this.paginationVal.emit(currentPage);
    (<HTMLInputElement>document.getElementById('tableHeader')).scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
  }

  goToCseFacilityMapped(userId) {
    let encryptedParams = btoa(`userId=${userId}`);
    this.router.navigateByUrl(`admin/cse-facility-mapped?${encryptedParams}`);
    sessionStorage.setItem('isClearFilter', 'false');
  }
}
